import React, { useState } from 'react';
import { Sparkles, RefreshCw, Bot, AlertCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { summarizeLead } from '../../services/aiService';

export default function AISummaryCard({ lead, onSummaryUpdated }) {
  const [summary, setSummary] = useState(lead?.aiSummary || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleSummarize = async (e) => {
    if (e) e.stopPropagation();
    if (!lead?.id) return;
    setLoading(true);
    setError('');
    try {
      const res = await summarizeLead(lead.id);
      if (res.success && res.summary) {
        setSummary(res.summary);
        if (onSummaryUpdated) onSummaryUpdated(res.summary);
      } else {
        setError('Failed to generate summary.');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Error generating AI summary');
    } finally {
      setLoading(false);
    }
  };

  const bullets = summary
    ? summary.split('\n').filter(line => line.trim().length > 0)
    : [];

  return (
    <div className="ld-card">
      <div className="ld-card-header" onClick={() => setIsCollapsed(!isCollapsed)}>
        <div className="ld-card-header-left">
          <Sparkles size={16} className="ld-card-icon" style={{ color: '#818cf8' }} />
          <span className="ld-card-title">AI REMARKS & EXECUTIVE SUMMARY</span>
          <span style={{
            fontSize: '11px',
            padding: '2px 8px',
            borderRadius: '9999px',
            background: 'rgba(99, 102, 241, 0.15)',
            color: '#818cf8',
            fontWeight: '600',
            border: '1px solid rgba(99, 102, 241, 0.3)'
          }}>
            Gemini 3.5 Flash Lite (500 FREE RPD)
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button
            onClick={handleSummarize}
            disabled={loading}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '12px',
              fontWeight: '600',
              padding: '4px 10px',
              borderRadius: '6px',
              background: '#4f46e5',
              color: '#ffffff',
              border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              transition: 'all 0.15s ease'
            }}
          >
            <RefreshCw size={13} className={loading ? 'animate-spin' : ''} />
            <span>{loading ? 'Analyzing...' : summary ? 'Re-Analyze' : 'Generate Summary'}</span>
          </button>
          <button className="ld-collapse-btn">
            {isCollapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
          </button>
        </div>
      </div>

      {!isCollapsed && (
        <div className="ld-card-body">
          {error && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '12px',
              color: '#f87171',
              background: 'rgba(239, 68, 68, 0.1)',
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid rgba(239, 68, 68, 0.2)'
            }}>
              <AlertCircle size={14} />
              <span>{error}</span>
            </div>
          )}

          {loading ? (
            <div style={{ padding: '24px 0', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
              <div className="ld-skeleton-pulse" style={{ width: 24, height: 24, borderRadius: '50%' }} />
              <span style={{ fontSize: '12px', color: 'var(--muted)' }}>Evaluating lead history with Gemini AI...</span>
            </div>
          ) : bullets.length > 0 ? (
            <div style={{
              background: 'var(--surface-2)',
              borderRadius: '8px',
              padding: '12px 14px',
              border: '1px solid var(--border)',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px'
            }}>
              {bullets.map((bullet, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '13px', color: 'var(--text)', lineHeight: '1.5' }}>
                  <span style={{ color: '#818cf8', fontWeight: 'bold' }}>•</span>
                  <span>{bullet.replace(/^[\s•*-]+/, '')}</span>
                </div>
              ))}
            </div>
          ) : (
            <div style={{
              padding: '16px',
              textAlign: 'center',
              background: 'var(--surface-2)',
              borderRadius: '8px',
              border: '1px dashed var(--border)',
              color: 'var(--muted)',
              fontSize: '12px'
            }}>
              <Bot size={24} style={{ margin: '0 auto 6px', opacity: 0.5 }} />
              <div>No AI summary generated yet. Click <strong>"Generate Summary"</strong> above.</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
